import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    GetById,
    Update,
    GetAllCandidates,
    GetAllPositions,
} from "adminApi/CandidateShortlistApi/CandidateShortlist";
import { validateForm } from "utils/validation";
import { CandidateShortlistRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditCandidateShortlistForm from "./components/EditCandidateShortlistForm";
import fields from "../json/CandidateShortlist.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";

const EditCandidateShortlist = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;
    const [loadingData, setLoadingData] = useState(false);

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce(
        (acc, field) => ({ ...acc, [field.name]: "" }),
        {}
    );

    // Form state
    const { values, errors, handleChange, setErrors, setValues } = useFormChange(
        initialValues,
        CandidateShortlistRules
    );

    // Fetch existing record by ID
    useEffect(() => {
        const fetchData = async () => {
            setLoadingData(true);
            const result = await GetById(id);
            if (result.data?.success) {
                const data = result.data.data;
                setValues({ ...initialValues, ...data });
            }
            setLoadingData(false);
        };
        if (id) fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    // Dropdown options
    const { data: CandidateOptions = [] } = useFetchAllData(GetAllCandidates);
    const { data: PositionOptions = [] } = useFetchAllData(GetAllPositions);

    // Form submit
    const { loading, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) =>
                formData.append(key, val ?? "")
            );
            return await Update({ id, data: formData });
        },
        (vals) => {
            const err = validateForm(vals, CandidateShortlistRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Candidate shortlist updated successfully"
    );

    if (loadingData) return <Spinner isSpinner />;

    return (
        <>
            {loading && <Spinner isSpinner={true} />}
            <EditCandidateShortlistForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loading}
                title="Edit Candidate Shortlist"
                CandidateOptions={CandidateOptions}
                PositionOptions={PositionOptions}
            />
        </>
    );
};

export default EditCandidateShortlist;
